import { useAsciiArt } from "./AsciiArtContext";
import { useMemo } from "react";
import { useSvgViewBoxZoom } from "../../hooks/useSvgViewBoxZoom";

export function AsciiArtViewer() {
    const {
        font,
        fontSize,
        viewBoxAttr,
        asciiGrid,
        canExport,
        handleDownload,
        imageDataUrl,
    } = useAsciiArt();

    const base = useMemo(() => {
        const [x, y, w, h] = viewBoxAttr.split(" ").map(Number);
        return { x, y, w, h };
    }, [viewBoxAttr]);

    const {
        svgRef,
        viewBoxAttr: viewBox,
        panHandlers,
        zoomPercent,
        zoomIn,
        zoomOut,
        resetView,
    } = useSvgViewBoxZoom({ base });

    return (
        <div className="panel-viewer ascii-art-viewer">
            <div className="path-tool-preview">
                <div className="svg-zoom-controls">
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={zoomOut}
                        title="Zoom out"
                    >
                        −
                    </button>
                    <span className="zoom-level">{zoomPercent}%</span>
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={zoomIn}
                        title="Zoom in"
                    >
                        +
                    </button>
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={resetView}
                        title="Reset zoom"
                    >
                        ⌂
                    </button>
                </div>
                <div className="svg-scroll-wrapper">
                    {!imageDataUrl ? (
                        <div className="svg-placeholder">
                            <p>Upload a raster image to generate ASCII art.</p>
                        </div>
                    ) : (
                        <div className="svg-container svg-container--fill">
                            <svg
                                ref={svgRef}
                                viewBox={viewBox}
                                xmlns="http://www.w3.org/2000/svg"
                                className="ascii-art-svg"
                                style={{ touchAction: "none" }}
                                {...panHandlers}
                            >
                                <g className="ascii-art">
                                    {asciiGrid.map((c, i) => (
                                        <text
                                            key={i}
                                            x={c.x}
                                            y={c.y}
                                            fontFamily={font}
                                            fontSize={fontSize}
                                            fill="black"
                                        >
                                            {c.char}
                                        </text>
                                    ))}
                                </g>
                            </svg>
                        </div>
                    )}
                </div>
                <div className="path-tool-footer">
                    <p className="path-tool-meta">
                        {asciiGrid.length > 0
                            ? `Generated ${asciiGrid.length} character${asciiGrid.length === 1 ? "" : "s"}.`
                            : "No characters generated."}
                    </p>
                    <button
                        type="button"
                        className="generic-button"
                        disabled={!canExport}
                        onClick={handleDownload}
                    >
                        Download result SVG
                    </button>
                </div>
            </div>
        </div>
    );
}
